import React from 'react';
import {Card,Button} from 'react-bootstrap'
import styled from 'styled-components'
import LongCard from './LongCard'
import LongCardInverted from './LongCardInverted'
import SmallCard from './SmallCard'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const StyledCol = styled(Col)`
    margin-top: 20px;
    margin-bottom: 20px;
    margin-right: 20px;
    margin-left: 20px;
`

const SmallCardContainer = ({refs}) => {
    return (
        <Container fluid style={{padding: '0', margin: '0'}}>
        <Row noGutters>
            <StyledCol><SmallCard title='The Value of Graffiti' writer='Ben Vassar / Peter Hummer' text='In a city that outsiders only see as blight and industrial ruins, color remains.' link='https://www.michigandaily.com/section/bside/value-graffiti' image='https://www.michigandaily.com/sites/default/files/styles/large/public/200913/IMG_8475.JPG?itok=SSvIlCrq'></SmallCard></StyledCol>
            <StyledCol><SmallCard title='TV + NYC' writer='San Della Fera' text='The streets of the Big Apple are overrun with characters from iconic shows, so much so that the city itself has become one of television’s most prolific stars.' link='https://www.michigandaily.com/section/bside/tv-nyc' image='https://www.michigandaily.com/sites/default/files/styles/large/public/200913/tomsrestaurant-01.png?itok=hsAFXavy'></SmallCard></StyledCol>
        </Row>
        <Row noGutters>
            <StyledCol><SmallCard title='Has Country Music Moved to the City?' writer='Katie Beekman' text='Whether one likes it or not, country music, in its many evolutions, has thrived in part because of the city, not in spite of it.' image='https://www.michigandaily.com/sites/default/files/styles/large/public/200913/Untitled_Artwork.jpg?itok=7P3NNJ6x' link='https://www.michigandaily.com/section/bside/has-country-music-moved-city'></SmallCard></StyledCol>
            <StyledCol><SmallCard title='Arbitrary Cities' writer='Kari Anderson' text='When it comes to popular movies or TV shows about Seattle, it never feels quite right, no matter how many Seattle sports references or aerial shots of the skyline they include.' link='https://www.michigandaily.com/section/bside/arbitrary-cities-why-setting-should-be-more-important-films' image='https://www.michigandaily.com/sites/default/files/styles/large/public/200913/space%20needle%20illustration.png?itok=_DOsyKEq'></SmallCard></StyledCol>
        </Row>
        </Container>
    );
}

export default SmallCardContainer;